/*
 *
 * BookingDetailActionsPopUp
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 19-Mar-2025
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import BookingDetailActionsPopUp from './BookingDetailActionsPopUp'
import * as actionLayer from '../../../../modules/BookingManagementActions'
import { doPopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(actionLayer, dispatch),
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  isLoading: state.loading?.local_BookingsManagementExecuteAction || false,
  data: state?.popup.popupData || {},
  selectedBooking: state?.BookingManagement?.selectedBooking || {}
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(BookingDetailActionsPopUp)
